// ----------------------------------------------------------------------------
// Snippet: Search
// ----------------------------------------------------------------------------
// Search bar, on header and on the Search Results template.
// ----------------------------------------------------------------------------


// -------------------------------------
// Dependencies
// -------------------------------------

// Scripts
import $ from 'jquery';

// Styles
import './_search-form.scss';


// $(document).ready(function(){
//     const SEARCH_FORM = '.search-box';
//     const SEARCH_ICON = '.search-box__toggle';
//     const SEARCH_INPUT = '.search__input';

//     // If you click anywhere outside of the search, close it
//     $('body').on('click', function(event) {
//       if (!$(event.target).closest(SEARCH_FORM).length) {
//         $(SEARCH_FORM).removeClass('is-active');
//       }
//     });

//     // When you click the search icon, toggle the open state
//     $(SEARCH_ICON).on('click', function(event) {
//       event.preventDefault();

//       let $currentParent = $(this).closest(SEARCH_FORM);

//       $currentParent.toggleClass('is-active');
//       $currentParent.find(SEARCH_INPUT).focus();
//     });

//     document.addEventListener('keyup', function(e) {
//         if (e.keyCode == 27 && $(SEARCH_INPUT).is(":focus")) {
//             $(SEARCH_FORM).removeClass('is-active');
//         }
//     });

//     // Allows label on mobile to also target the search
//     $('.search-box--header .form__label').on('click', function(event) {
//       $(this).closest('.search-box').toggleClass('is-active');
//     });

//     // // On desktop, you're not clicking the label so we need to auto-focus when you click the icon
//     // $('.search__icon').on('click', function(event) {
//     //   $('.search__input').focus();
//     // });
// });

// ----------------------------------------------------------------------------
// Component: Search
// ----------------------------------------------------------------------------
//
// Search bar, on header and on the Search Results template.
//
// ----------------------------------------------------------------------------

const SEARCH_FORM = '.search-box--header';
const SEARCH_FORM_AFTER = '.search-box--header:after';
const SEARCH_ICON = '.search-box__toggle';
const SEARCH_INPUT = '.search__input';

// If you click anywhere outside of the search, close it
$('body').on('click', function(event) {
    if (!$(event.target).closest('.form--search').length && !$(event.target).closest(SEARCH_ICON).length) {
        $(SEARCH_FORM).removeClass('is-active');
    }
});


// When you click the search icon, toggle the open state
$(SEARCH_ICON).on('click', function(event) {
  event.preventDefault();
  let $currentParent = $(SEARCH_ICON).closest('header').find(SEARCH_FORM);

  $currentParent.toggleClass('is-active');

  if($currentParent.hasClass('is-active')){
    $currentParent.find(SEARCH_INPUT).focus();
  }


  // Clear header classes for mobile
  $('.header').removeClass('js--isOpen');
  $('.menu--default').removeClass('js--isOpen');
  $('.header__link--menu').removeClass('js--isOpen');
});


// Allows label on mobile to also target the search
$('.search-box--header .form__label').on('click', function(event) {
  $(this).closest('.search-box').toggleClass('is-active');
});
